import { Button, Select } from "antd";
import React, { useEffect, useState } from "react";

import arrowDown from "../../assets/icons/arrow-down12.png";
import addCircle from "../../assets/icons/add-circle.png";
import call from "../../assets/icons/call.svg";
import sms from "../../assets/icons/sms3.svg";

export default function PatientDropdown({
  breakdown,
  isApproved,
  allPatients,
  selectedPatient,
  setShowAddPatient,
  currentPatientName,
  isSettingPatientId,
  setSelectedPatient,
  setTempSelectedPatients,
  setBreakdownToSetPolicy,
  setIsPatientDropdownEmpty,
  setShowSelectPolicyItemModal,
  customClass = "",
}) {
  const [isOpen, setIsOpen] = useState(false);

  const dropdownPatientsOptions = allPatients.map((patient) => ({
    value: patient.id,
    label: <SelectPatientDropDownItem name={`${patient.first_name} ${patient.last_name}`} email={patient.email} phone={patient.phone} />, // String for selected value display
  }));

  useEffect(function () {
    if (setIsPatientDropdownEmpty) setIsPatientDropdownEmpty(currentPatientName || selectedPatient ? false : true);
  }, []);

  function handleChangePatient(value) {
    const patient = allPatients.find((p) => p.id === value);
    setSelectedPatient(patient);
    setTempSelectedPatients({ temp_patient: currentPatientName, selected_patient: patient });
    setShowSelectPolicyItemModal(true);

    if (setIsPatientDropdownEmpty) setIsPatientDropdownEmpty(false);
  }

  return (
    <Select
      showSearch
      placeholder="Select Patient"
      optionFilterProp="label"
      onClick={(e) => {
        e.stopPropagation();
        if (setBreakdownToSetPolicy) setBreakdownToSetPolicy(breakdown);
      }}
      options={dropdownPatientsOptions}
      className={`${customClass} select-patient-id ${(currentPatientName || selectedPatient) && "no-transparent-background"}`}
      value={selectedPatient ? `${selectedPatient.first_name} ${selectedPatient.last_name}` : undefined}
      suffixIcon={<img style={{ width: 20, transform: `rotate(${isOpen ? "180deg" : "0"})` }} src={arrowDown} alt="arrow-down" />}
      onChange={handleChangePatient}
      onOpenChange={(open) => setIsOpen(open)}
      disabled={isSettingPatientId || isApproved}
      popupRender={(menu) => (
        <>
          {menu}
          <Button
            type="primary"
            style={{
              width: "100%",
              border: "1px solid #6B43B5",
              borderRadius: "0 0 10px 10px",
              backgroundColor: "white",
              color: "#6B43B5",
              padding: 30,
            }}
            onClick={() => setShowAddPatient(true)}
          >
            <img src={addCircle} alt="add" />
            Add New Patient
          </Button>
        </>
      )}
      filterOption={(input, option) => {
        if (!input) return true;
        if (!option.label) return false;

        return (
          (option.label.props.name && option.label.props.name.toLowerCase().includes(input.toLowerCase())) ||
          (option.label.props.email && option.label.props.email.toLowerCase().includes(input.toLowerCase())) ||
          (option.label.props.phone && option.label.props.phone.toString().toLowerCase().includes(input.toLowerCase()))
        );
      }}
      optionLabelProp="label"
    />
  );
}

function SelectPatientDropDownItem({ name, email, phone }) {
  return (
    <div style={{ padding: "2px 4px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 5 }}>
        <p style={{ margin: 0, fontSize: 14 }}>{name}</p>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src={call} alt="phone" style={{ width: 15 }} />
          <span style={{ color: "#848696", fontSize: 12 }}>{phone}</span>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <img src={sms} alt="phone" style={{ width: 15 }} />
        <span style={{ color: "#848696", fontSize: 12 }}>{email}</span>
      </div>
    </div>
  );
}
